import styled from "styled-components";

export const HeroSectionWrapper = styled.section`
    background: linear-gradient(180deg, rgba(143, 197, 234, 0.3) 0%, rgba(110, 247, 218, 0.3) 100%);

    .intro-text{
        font-size: 1.25rem;
    }
`